import { Component, EventEmitter, Input, Output } from '@angular/core';
import { to64decode } from 'src/app/helpers/base64';
import { getLanguageCookie } from 'src/assets/language';

@Component({
  selector: 'app-choose-reference-personas',
  templateUrl: './choose-reference-personas.component.html',
  styleUrls: ['./choose-reference-personas.component.scss']
})
export class ChooseReferencePersonasComponent {
  @Output() toggleModal: EventEmitter<any> = new EventEmitter<any>();
  @Input() referenceTreeShared: boolean = false;
  @Input() type: string = 'personas'
  corporationName: string = '';
  
  constructor(){
    this.corporationName = to64decode(localStorage.getItem('corporation'))?.name ?? '';
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  exitModal(){
    this.toggleModal.emit()
  }

  saveAndClose(){
    this.toggleModal.emit(!this.referenceTreeShared)
  }

  async getType(): Promise<string> {
    return this.type || 'personas'
  }
}
